import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// "2026-06" -> "06.2026"
export function formatMonat(monat) {
  if (!monat || typeof monat !== "string") return monat || "";
  const [y, m] = monat.split("-");
  if (!y || !m) return monat;
  return `${m}.${y}`;
}

// "2026-06-07" -> "07.06.2026"
export function formatDatum(datum) {
  if (!datum || typeof datum !== "string") return datum || "";
  const parts = datum.slice(0, 10).split("-");
  if (parts.length !== 3) return datum;
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
}
